module.exports = __webpack_public_path__ + "f572638f/img/ion_calendar-number.3ac5bd07.svg";